import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { ComponentsService } from '../../services/ComponentsService';
import * as BullCache from "../../util/BullCache";
import { customStyles, the } from './customStyles';

const SubBrokerDropdown = ({ selectedAdmin, selectedBrokerId,selectedMaster, setSelectedOption, setSelectedSubBrokerId,setSelectedClientId }) => {
  const [subBroker, setSubBroker] = useState([]);
  const [selectedOption, setSelectedOptionInternal] = useState(null); 

  var user = BullCache.getFromCache("user");

  useEffect(() => {
     setSelectedOptionInternal(null);
     setSelectedOption(null);

    const fetchSubBrokerData = async () => {
      let adminId = user?.adminId; 

      if (selectedBrokerId) {
        adminId = selectedBrokerId; 
      } else if (selectedMaster) {
        adminId =  selectedMaster.value; 
      }else if (selectedAdmin) {
        adminId =  selectedAdmin.value; 
      }


      if (adminId) {
        try {
          const res = await ComponentsService.getSubBroker({ adminId });
          if (res.code === 1 && res.data.subbrokerList.length > 0) {
            setSubBroker(res.data.subbrokerList); 
          } else {
            setSubBroker([]); 
          }
        } catch (error) {
          console.error('Error fetching subBroker data:', error);
        }
      }
      else {
        setSubBroker([]); 
      }
    };

      fetchSubBrokerData();

  }, [selectedAdmin, selectedMaster, selectedBrokerId]); 

  const subBrokerOption = subBroker.map((item) => ({
    value: item.adminId,
    label: `${item.firstName} (${item.userName})`, 
  }));

  const handleSelectChange = (selected) => {
    const userId = selected ? selected.value : null; 
    setSelectedOptionInternal(selected); 
    setSelectedSubBrokerId(selected?.value);
    setSelectedOption(selected); 
    
  };

  return (
    <div>
      <Select
        options={subBrokerOption} 
        value={selectedOption} 
        onChange={handleSelectChange} 
        placeholder="Select" 
        isSearchable 
        className="text-black fss-01"
        size="sm"
        theme={the}
        styles={customStyles}
        isClearable
      />
    </div>
  );
};

export default SubBrokerDropdown;
